import React from "react";
import "./HealthOneFeatures.scss";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";

const HealthOneFeatures = () => {
  // Fetch media where section is "event"
  const { documents: eventMedia, error } = useCollection("media", ["section", "==", "event"]);

  return (
    <section className="health-one-features-section">
      <div className="health-one-top-content">
        <div className="text-content">
          <p className="health-one-common-parent-sub-heading">OUR CAMP KEY FEATURES</p>
          <h2 className="health-one-common-black-parent-heading">
            Features that Make Camp Life <br />
            Simpler and More Organized
          </h2>
          <p className="description">
            Our platform offers tools for campers and organizers to stay safe,
            organized, and connected while enjoying their adventure in the great
            outdoors.
          </p>
        </div>
        <button className="health-one-common-parent-border-btn">Explore More</button>
      </div>

      <div className="cards-container">
        {eventMedia &&
          eventMedia.slice(0, 3).map((item, index) => (
            <div className="card" key={index}>
              <img src={item.mediaUrl} alt={`event-img-${index}`} />
            </div>
          ))}
      </div>
    </section>
  );
};

export default HealthOneFeatures;
